import * as CryptoJS from 'crypto-js';

export class CryptoUtils {
    static sha256(value: string): string {
        return CryptoJS.SHA256(value).toString(CryptoJS.enc.Hex);
    }

    static hashWithSaltCode(value: string, saltCode: string): string {
        if (!value) return '';
        return this.sha256(value?.replace(/[.\-/\s]/g, '') + saltCode);
    }
}
